package app.alefly.domain.model

import kotlinx.datetime.Instant
import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

@Serializable
enum class ChallengeStatus {
    @SerialName("active")
    ACTIVE,

    @SerialName("expired")
    EXPIRED,

    @SerialName("disabled")
    DISABLED,
}

@Serializable
data class ChallengeShare(
    val slug: String,
    val deepLinkPath: String,
)

@Serializable
data class ChallengeStats(
    val plays: Int,
    val completions: Int,
)

@Serializable
data class Challenge(
    val id: ChallengeId,
    val tenantId: TenantId,
    val quizId: QuizId,
    val locale: String,
    val difficulty: Difficulty,
    val hintsEnabled: Boolean,
    val questionCount: Int,
    val questionIds: List<QuestionId>,
    val createdByClientId: ClientId? = null,
    val createdAt: Instant,
    val expiresAt: Instant,
    val status: ChallengeStatus,
    val share: ChallengeShare,
    val stats: ChallengeStats = ChallengeStats(plays = 0, completions = 0),
    val roundNumber: Int = 0,
)
